import keyMirror from 'keymirror';
import { BRAND_NAME } from '../../services/Constants';
import jetpackImage from '../../images/illustrations/rectangular/jetpackWithoutBg.svg';
import errorImage from '../../images/illustrations/rectangular/404.svg';
import typingImage from '../../images/illustrations/methods/typing.svg';
import explanationVideoImage from '../../images/illustrations/supporting/explanationVideo.svg';
import glidingArrowImage from '../../images/illustrations/supporting/glidingArrow.svg';
import triangleImage from '../../images/illustrations/productPhotos/triangle.png';
import starImage from '../../images/illustrations/productPhotos/star.png';
import gamepadImage from '../../images/illustrations/productPhotos/gamepad.png';
import laptopImage from '../../images/illustrations/supporting/laptopwSubjects.svg';
import pointerTestImage from '../../images/illustrations/supporting/pointerTest.svg';

export const offerActionTypes = keyMirror({
	OFFER_REQUEST: null,
	OFFER_REQUEST_SUCCESS: null,
	OFFER_REQUEST_ERROR: null,
	GET_FULL_ADDRESS: null,
	GET_FULL_ADDRESS_SUCCESS: null,
	GET_FULL_ADDRESS_ERROR: null,
	GET_OFFER_ABILITY: null,
	GET_OFFER_ABILITY_SUCCESS: null,
	GET_OFFER_ABILITY_ERROR: null,
	CLEAR_OFFER_STATE: null,
	ACCEPT_REVERSE_TRIAL_OFFER_REQUEST: null,
});

export const getContentByType = (type, t) => {
	return {
		title: t('offer.title', { context: type, brandName: BRAND_NAME }),
		usp: [
			{
				id: 1,
				image: typeMapImages[0][type],
				text: t('offer.usp.1', { context: type }),
			},
			{
				id: 2,
				image: typeMapImages[1][type],
				text: t('offer.usp.2', { context: type }),
			},
			{
				id: 3,
				image: typeMapImages[2][type],
				text: t('offer.usp.3', { context: type }),
			},
		],
		description: t('offer.description', { context: type, brandName: BRAND_NAME }),
		success: {
			title: t('offer.process_result.title_success', { context: type }),
			description: t('offer.process_result.description_success', { context: type }),
			image: jetpackImage,
		},
		error: {
			title: t('offer.process_result.title_error'),
			description: t('offer.process_result.description_error'),
			image: errorImage,
		},
	};
};

export const typeMap = {
	premium_month: 'premium_month',
	'reverse-trial': 'reverse_trial',
};

export const typeMapImages = [
	{
		premium_month: typingImage,
		reverse_trial: laptopImage,
		welcome_box: gamepadImage,
	},
	{
		premium_month: explanationVideoImage,
		reverse_trial: explanationVideoImage,
		welcome_box: triangleImage,
	},
	{
		premium_month: glidingArrowImage,
		reverse_trial: pointerTestImage,
		welcome_box: starImage,
	},
];
